import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Check, CheckCheck, Info, X } from 'lucide-react';
import React, { FC } from 'react';
import { ExpandableTableRow } from '../NewVerificationTab.data';
import { CellState, InfoIconContainer, StatusCellWrapper, StatusIconContainer } from '../NewVerificationTab.styles';
import { StatusIcon } from './StatusIcon';

interface AutoMatchCellContentProps {
  row: ExpandableTableRow;
  state: CellState;
}

const AutoMatchIcon: FC<{ state: CellState; row: ExpandableTableRow }> = ({ state, row }) => {
  switch (state.autoMatchIcon) {
    case 'question':
    case 'dash':
      return <span className='text-[#1c2024] text-sm font-bold leading-4'>?</span>;
    case 'checkcheck':
      return <CheckCheck className='w-4 h-4 text-green-600' />;
    case 'check':
      return <Check className='w-4 h-4 text-green-600' />;
    case 'x':
      return <X className='w-4 h-4 text-red-600' />;
    default: {
      const statusType = typeof row.automatedMatching === 'string' ? row.automatedMatching : null;
      return <StatusIcon status={statusType as any} variant='automated' />;
    }
  }
};

export const AutoMatchCellContent: FC<AutoMatchCellContentProps> = ({ row, state }) => (
  <StatusCellWrapper
    status={row.automatedMatching ?? null}
    data-testid={`verification-automatch-${row.dataPointType}`}
    data-status={row.automatedMatching ?? ''}
    data-reason={row.reason ?? ''}
  >
    <StatusIconContainer>
      <AutoMatchIcon state={state} row={row} />
    </StatusIconContainer>
    {row.automatedMatching === 'PartialMatch' && (
      <InfoIconContainer>
        {row.reason ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className='w-4 h-4 text-gray-600 cursor-pointer' />
            </TooltipTrigger>
            <TooltipContent className='!bg-black !text-white !flex !items-center !justify-center !px-2 !py-1 [&>svg]:bg-black [&>svg]:fill-black [&>*:not(:first-child)]:hidden [&>p]:!m-0 [&>p]:!leading-none [&>p]:!text-center'>
              <p>{row.reason}</p>
            </TooltipContent>
          </Tooltip>
        ) : (
          <Info className='w-4 h-4 text-gray-600' />
        )}
      </InfoIconContainer>
    )}
  </StatusCellWrapper>
);
